import { render, staticRenderFns } from "./anniv_client.vue?vue&type=template&id=3ab9b954&scoped=true&"
import script from "./anniv_client.vue?vue&type=script&lang=js&"
export * from "./anniv_client.vue?vue&type=script&lang=js&"
import style0 from "./anniv_client.vue?vue&type=style&index=0&id=3ab9b954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab9b954",
  null
  
)

export default component.exports